<template>
    <div class="photo_book_image">
        <div class="loader" v-if="loading"></div>
        <b-img-lazy v-bind="mainProps" :src="retrievePhotoBookImage()" alt=""></b-img-lazy>
    </div>
</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-image",
    components: {
        Modal,
        BaseAlert,
    },
    props: {
        image: '',
    },
    data() {
        return {
            loading: false,
            mainProps: {
                center: true,
                fluidGrow: true,
                blank: true,
                blankColor: '#bbb',
                width: 600,
                height: 400,
            },
            photo_book_image: '',
        };
    },
    methods: {
        retrievePhotoBookImage() {
            return this.$image_host+"/"+this.image.image.medium.url; 
            this.loading = true;
            let query = {};
            query["imgid"] = this.image.id;
            this.$api.getPhotoBookImage(this.image.imageable_id, this.image.id)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return this.$image_host+"/"+this.photo_book_image.image.medium.url; 
                });      
        },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
    },
    mounted() {
        console.log(this.image);
        //console.log(this.photo_book_id);
        //console.log("Loading image from sererv...");
        //this.retrievePhotoBookImage();
    },
};
</script>
<style scoped>
.photo_book_image_2{
    background-color:green;
    padding: 0;
    margin: 0;
}
</style>